import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const PushChannelDashboard = lazy(() =>
  import("@scenes/ChannelDashboard/components/PushChannelDashboard").then((module) => ({
    default: module.PushChannelDashboard,
  }))
);

export const pushPerformanceNRO: NavigationRoutingObject = {
  Component: PushChannelDashboard,
  componentFeatureFlippers: ["push_analytics_hub"],
  section: "analytics",
  pageNameForTracking: () => "Push Performance",
  heading: (t: I18nT<"dashboard-navigation">) => t("push-performance-sidebar-pill-menu-option", "Push Performance"),
  tag: "new",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission, featureOn }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });

    return (
      featureOn("push_analytics_hub") &&
      (isImpersonating || userHasViewAppUsagePermission || userHasViewReportingPermission)
    );
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("push-performance-alt-keyword-1", "Push"),
        t("push-performance-alt-keyword-2", "Mobile push"),
        t("push-performance-alt-keyword-3", "Push engagement"),
        t("push-performance-alt-keyword-4", "Push sends"),
        t("push-performance-alt-keyword-5", "Delivery rate"),
        t("push-performance-alt-keyword-6", "Conversion rate"),
        t("push-performance-alt-keyword-7", "Bounce rate"),
        t("push-performance-alt-keyword-8", "Unsubscribe rate"),
        t("push-performance-alt-keyword-9", "Uninstall rate"),
        t("push-performance-alt-keyword-10", "Reachable audience"),
        t("push-performance-alt-keyword-11", "Push insights"),
        t("push-performance-alt-keyword-12", "Deliverability center"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
};
